import React from "react";
import {
    Bar,
    BarChart,
    CartesianGrid, Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";

export default function AddressRDI({ data }) {
    const COLORS = ["#2d5d7e", "#ee5a38e6", "#fdba43", "#FF8042", "#0034C4",       "#003f5c",
        "#58508d",
        "#bc5090",
        "#ff6361",
        "#ffa600",
        "#2ca02c",
        "#17becf",
        "#d62728",
        "#9467bd",
        "#8c564b"
    ];

    const DARKER_COLORS = ["#1a3a4d", "#b83f26", "#c98f1f", "#cc5d2f", "#00208a", "#002038",
        "#3a3560",
        "#8a3562",
        "#cc4442",
        "#c97b00",
        "#1f7a1f",
        "#0f8a9a",
        "#a01d1f",
        "#6b4a8a",
        "#5f3c35"
    ];

    const rows = data ?? [];

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    return (
        <div className="hc-box">
            <div className="hc-title">Address RDI</div>
            <div className="hc-body">
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={rows}
                            dataKey="count"
                            nameKey="addressRDI"
                            cx="50%"
                            cy="50%"
                            outerRadius={100}
                            label={({ name, percent }) =>
                                `${name}: ${(percent * 100).toFixed(1)}%`
                            }
                        >
                            {rows.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={DARKER_COLORS[index % DARKER_COLORS.length]}
                                    strokeWidth={2}
                                />
                            ))}
                        </Pie>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
